import React from 'react';

/**
 * Strips HTML/XHTML tags from a string for use in aria-labels or other plain text contexts
 * @param {string} html - The HTML string to clean
 * @returns {string} - Plain text without HTML tags
 */
export const stripHtmlTags = (html) => {
	if (!html || typeof html !== 'string') return '';

	// Remove HTML tags and decode common HTML entities
	return html
		.replace(/<[^>]*>/g, '') // Remove all HTML tags
		.replace(/&nbsp;/g, ' ') // Replace non-breaking spaces
		.replace(/&amp;/g, '&') // Replace ampersands
		.replace(/&lt;/g, '<') // Replace less than
		.replace(/&gt;/g, '>') // Replace greater than
		.replace(/&quot;/g, '"') // Replace quotes
		.replace(/&#39;/g, "'") // Replace apostrophes
		.replace(/\s+/g, ' ') // Replace multiple whitespace with single space
		.trim(); // Remove leading/trailing whitespace
};

export const concatenateIfMany = (array) =>
	array?.map((item, i) => {
		const label = item?.Name ? item?.Name : item;
		return (
			<span key={`${label}-${i}`}>
				{label}
				{i + 1 != array.length && ', '}
			</span>
		);
	});
